const ufeApi = require('services/api/ufeApi');
const { userXTimestampHeader } = require('utils/Headers');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Create+User+API


function createUser(profileData) {
    let url = '/api/users/profile';
    return ufeApi.makeRequest(url, {
        method: 'POST',
        headers: userXTimestampHeader(),
        body: JSON.stringify(profileData)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = { createUser };
